// extracted by mini-css-extract-plugin
export var innerWrapper = "attachments-to-send-list-module--inner-wrapper--3ad20";
export var item = "attachments-to-send-list-module--item--dc874";
export var list = "attachments-to-send-list-module--list--70be3";
export var titleHolder = "attachments-to-send-list-module--title-holder--30d73";
export var wrapper = "attachments-to-send-list-module--wrapper--d97f6";